// Application specific configuration variables

import { floor } from "lodash";
import { HrRoutes } from "./components/hr/router/HrRoutes";

// potentially sourced from process.env.REACT_APP_*
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL as string;

export const DAL_DOMAIN = "letmework.dotsandlines.io";

export const MOBILE_BREAKPOINT = 1000;

export const DOWNLOAD_VIA_BROWSER = false;

export const SEARCH_DEBOUNCE_MS = 500;

/* NAVBAR HEIGHT */

export const NAVBAR_HEIGHT = 83;

/* TABLE LINE HEIGHT */

export const TABLE_LINE_HEIGHT = 48;

export const ROWS_PER_PAGE = floor((window.innerHeight - 400) / TABLE_LINE_HEIGHT);

export const INITIAL_ROUTE = HrRoutes.DASHBOARD;

export const DEBUG = true;
export const ERROR_SNACKBAR_DURATION = 3000;

export const ENABLE_MOVE_FROM_EVIDENCE_TO_RECEIVED = true;

export const INITIAL_KANBAN_COLUMN_ELEMENTS = 5;

export const POLLING_NOTIFICATIONS_MS = 60 * 1000;
//the time it takes for a dialog to close
export const DIALOG_TRANSITION_TIME = 150;

export const DAL_HOMEPAGE = "https://www.dotsandlines.io/";
export const AAA_HOMEPAGE = "https://www.allaboutapps.at/";

export const DAL_PRIVACY_LINK = "https://www.dotsandlines.io/datenschutz/";
export const AAA_PRIVACY_LINK = "https://www.allaboutapps.at/datenschutz/";

export const LARGE_FILE_SIZE_MB = 100;
export const ADDITIONAL_FILES_MAX_SIZE_MB = 20;

export const LOADING_INDICATOR_DELAY_MS = 300;

export const TOKEN_EXCHANGE_THRESHOLD_MS = 5000;

export const BASE_NAME = "/webapp";

export const APPROXIMATE_CARD_HEIGHT = 140;
